import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuestionTypeOptions } from "../../hooks/groups/QuestionTypes";

function GroupQuestionsSelectInput({ index, value = "", disabled=false, onChange }) {
    const { t, i18n } = useTranslation();

    const [inputValue, setInputValue] = useState(value);

    const questionTypeOptions = useQuestionTypeOptions();

    useEffect(() => {
        if(value) {
            setInputValue(value);
        }
    }, [value]);
    
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        if (typeof onChange === 'function') {
            onChange({
                type: 'onChange',
                data: event.target.value,
                answer: event.target.options[event.target.selectedIndex].dataset.answer,
                index: index,
            });
        }
    };

    return (
        <>
            <select
                name={index}
                value={inputValue}
                tabIndex="0"
                onChange={handleInputChange}
                disabled={disabled}>

                {questionTypeOptions.map((option) => {
                    return (
                        <option
                            key={option.name}
                            value={option.name}
                            data-answer={option.answer}>
                            {t("common." + option.name)}
                        </option>
                    );
                })}
            </select>
        </>
    );
}

export default GroupQuestionsSelectInput;
